<template>
  <div class="footer-container">
    <div class="copyright">
      <a href="#">
        <img id="logo" src="@/assets/greo-logo-white.png"/>
      </a>
      <h3>Copyright 2018 Greo, Inc.</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.footer-container {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 2em;
  padding-bottom: 1em;
}

.copyright {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#logo {
  width: 2em;
  opacity: 0.5;
  cursor: pointer;
}

h3 {
    color: #FFFFFF;
    font-weight: 300;
    font-size: 0.75em;
    text-transform: uppercase;
    letter-spacing: 0.3em;
    opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue